var _path;

var _excluded = ["title", "titleId"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartFavoriteFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.820 4.027 C 7.231 4.099,6.581 4.288,6.113 4.523 C 4.629 5.270,3.507 6.826,3.116 8.680 C 2.997 9.243,2.988 10.240,3.096 10.800 C 3.544 13.115,5.364 15.491,8.460 17.801 C 9.456 18.544,10.596 19.273,11.512 19.752 L 12.004 20.009 12.397 19.807 C 13.273 19.358,14.530 18.556,15.538 17.803 C 18.618 15.502,20.387 13.211,20.885 10.880 C 21.012 10.284,21.012 9.284,20.884 8.680 C 20.380 6.296,18.754 4.534,16.659 4.101 C 15.680 3.899,14.550 4.033,13.651 4.459 C 13.146 4.699,12.770 4.957,12.352 5.355 L 12.000 5.689 11.644 5.350 C 10.866 4.610,9.940 4.171,8.881 4.042 C 8.558 4.002,8.078 3.995,7.820 4.027 ",
    stroke: "none",
    fillRule: "evenodd",
    fill: "black"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFavoriteFilled);
export default __webpack_public_path__ + "static/media/heart-favorite-filled.2f9dcca4.svg";
export { ForwardRef as ReactComponent };